import { get, post } from './axios.js'

/**
 * 화면메뉴 리스트 조회 - /capr/menuList
 * @returns
 */
export async function menuList() {
  try {
    const result = await post('/capr/menuList', {})
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 화면메뉴 수정 - /capr/cpEdit
 * @param {object} params
 * @property {string} params.cp_seq - Seq 
 * @property {string} params.tb_id - 캡션ID
 * @property {string} params.caption_nm - 캡션명 
 * @property {string} params.cd_nm - 캡션속성
 * @property {string} params.cp_format - 캡션포맷
 * @property {string} params.cp_cd - 캡션속성값
 * @property {string} params.cp_length - 캡션길이
 * @property {string} params.cp_required - 캡션필수여부
 * @property {string} params.col_id - 타입  
 * @property {string} params.enable_yn - 사용여부
 * @property {string} params.cp_required - 필수여부
 * @property {string} params.view_sort - 우선순위
 * @property {string} params.note - 비고  
 * @returns
 */
export async function cpEdit(params = {}) {
  try {
    const result = await post('/capr/cpEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * caption 속성 조회 - /capr/cpList
 * @param {object} params
 * @property {string} params.scren_id
 * @property {string} params.tb_id
 * @returns
 */
export async function cpList(params = {}) {
  try {
    const result = await post('/capr/cpList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * caption 내용 상세 조회 - /capr/cpCtntSelect
 * @param {object} params
 * @property {string} params.tb_id
 * @property {string} params.cap_seq
 * @returns
 */
export async function cpCtntSelect(params = {}) {
  try {
    const result = await post('/capr/cpCtntSelect', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * caption 상세 내용 저장/수정 - /capr/cpCtntEdit
 * @param {object} params
 * @property {string} params.cap_seq
 * @property {string} params.seq
 * @property {string} params.tb_id
 * @returns
 */
export async function cpCtntEdit(params = {}) {
  try {
    const result = await post('/capr/cpCtntEdit', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * caption 삭제 - /capr/cpCtntDel
 * @param {object} params
 * @property {string} params.cap_seq
 * @property {string} params.tb_id
 * @returns
 */
export async function cpCtntDel(params = {}) {
  try {
    const result = await post('/capr/cpCtntDel', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}